import React from "react";
import { Row } from "react-bootstrap";
import { Routes, Route, useLocation } from "react-router-dom";
import { ScreensPage } from "./ScreensPage";
import { ScreensSidebar } from "./components"
import { ScreenPage } from "./ScreenPage";
import { NavigationHelper } from "../helpers";
import { AccountWarnings } from "../components/AccountWarnings";

export const ScreensRouter: React.FC = () => {
  const location = useLocation();
  const [refreshKey, setRefreshKey] = React.useState("");
  React.useEffect(NavigationHelper.hideMobileSidebar, [location.pathname]) // eslint-disable-line

  const refreshSidebar = () => {
    setRefreshKey(NavigationHelper.getRefreshKey());
  }



  return (
    <>
      <a href="about:blank" onClick={e => { e.preventDefault(); NavigationHelper.toggleMobileSidebar() }} className="d-md-none" id="sidebarToggle"><i className="fas fa-bars"></i></a>
      <Row>
        <nav className="col-sm-3 col-md-2 d-none d-md-block bg-dark sidebar" id="sidebar">
          <ScreensSidebar refreshKey={refreshKey} />
        </nav>
        <main role="main" className="col-sm-12 ml-sm-auto col-md-10 pt-3">
          <AccountWarnings />
          <Routes>
            <Route path="/:id" element={<ScreenPage refreshSidebar={refreshSidebar} />} />
            <Route path="/" element={<ScreensPage />} />
          </Routes>
        </main>
      </Row>
    </>
  );
};